import React from "react";
import Scaffold from "../Scaffold";
import { Modal, ModalProps } from "antd";
import Styles from "./BaseDialog.module.scss";
import { TYPE_LOADING_ENUM } from "../../../applications/constants/AppConst";

export interface BaseDialogProps extends ModalProps {
  isLoading?: boolean;
  typeLoading?: TYPE_LOADING_ENUM;
}

const BaseDialog: React.FC<BaseDialogProps> = (props) => {
  const {
    typeLoading = TYPE_LOADING_ENUM.REPLACE,
    footer,
    isLoading,
    children,
    open = true,
    className = "",
    ...rest
  } = props;

  return (
    <Modal
      open={open}
      centered
      closable={false}
      loading={isLoading}
      maskClosable={false}
      confirmLoading={isLoading}
      footer={footer}
      className={`${Styles.accBaseDialog} ${className}`}
      styles={{
        body: {
          maxHeight: "70vh",
          overflow: "auto",
        },
      }}
      {...rest}
    >
      <Scaffold typeLoading={typeLoading} isLoading={isLoading ?? false}>
        {children}
      </Scaffold>
    </Modal>
  );
};

export default BaseDialog;
